import React from 'react';
import { Link } from 'react-router-dom';
import { getMediaUrl } from '../../utils/api';
import './ServiceCard.css';

const StarRating = ({ rating, count }) => (
  <div className="star-row">
    <div className="stars">
      {[1,2,3,4,5].map(n => (
        <span key={n} className={`star ${n <= Math.round(rating) ? 'filled' : ''}`}>★</span>
      ))}
    </div>
    <span className="star-count">({count})</span>
  </div>
);

export default function ServiceCard({ service }) {
  const { id, title, description, price, priceType, images, avgRating, totalReviews, seller, category, city, state } = service;

  const priceLabel = priceType === 'hourly' ? '/hr' : priceType === 'starting_at' ? '+' : '';
  const fallbackImg = `https://ui-avatars.com/api/?name=${encodeURIComponent(title)}&size=400&background=FDE68A&color=92400E&bold=true&format=svg`;

  return (
    <Link to={`/services/${id}`} className="service-card">
      <div className="service-card-img-wrap">
        <img
          src={images?.[0] ? getMediaUrl(images[0]) : fallbackImg}
          alt={title}
          className="service-card-img"
          onError={e => { e.target.src = fallbackImg; }}
        />
        {category && <span className="service-card-badge">{category.name}</span>}
      </div>

      <div className="service-card-body">
        {seller && (
          <div className="service-card-seller">
            <div className="avatar avatar-sm">
              {seller.avatar
                ? <img src={getMediaUrl(seller.avatar)} alt={seller.firstName} />
                : `${seller.firstName?.[0]}${seller.lastName?.[0]}`
              }
            </div>
            <span>{seller.businessName || `${seller.firstName} ${seller.lastName}`}</span>
          </div>
        )}

        <h3 className="service-card-title">{title}</h3>
        <p className="service-card-desc">{description?.substring(0, 90)}...</p>

        <StarRating rating={avgRating || 0} count={totalReviews || 0} />

        <div className="service-card-footer">
          <div className="service-card-price">
            <span className="price-from">{priceType === 'starting_at' ? 'From ' : ''}</span>
            <span className="price-amount">${price?.toFixed(2)}</span>
            <span className="price-unit">{priceLabel}</span>
          </div>
          {(city || state) && (
            <span className="service-card-location">📍 {[city, state].filter(Boolean).join(', ')}</span>
          )}
        </div>
      </div>
    </Link>
  );
}
